import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { GenericCarousel } from './generic-carousel';

export function StaffPicksCarousel(props) {
  const flags = useFlags();
  const isProductCardsV2Enabled = flags['growth.ecomm.product-card-v2.rollout'] ?? false;

  const { loading, products } = useDispensaryProducts({
    filters: {
      sortBy: `popularSortIdx`,
      staffPicks: true,
    },
    perPage: 25,
  });
  const title = `Staff Picks`;

  if (!products?.length && !loading) {
    return null;
  }

  if (isProductCardsV2Enabled) {
    return (
      <ProductCarousel
        products={products}
        isLoading={loading}
        hideTitle={props?.showTitle === false}
        hideLink={props?.showLink === false}
        title={title}
      />
    );
  }

  const sectionProps = {
    ...props,
    isLoading: loading,
    label: title,
    products,
  };

  return <GenericCarousel {...sectionProps} />;
}
